import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

  constructor(private translate: TranslateService) {
    translate.addLangs(['fr', 'it','en']);
    /*translate.setDefaultLang('en');
    translate.use('en');*/
    
    translate.setDefaultLang('fr')
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/fr|it|en/) ? browserLang : 'fr');
  }
}
